
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  TraceConnectParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\TraceConnectParameters.ts

export class TraceConnectParameters {

  // string OldToken
  public OldToken?: string=null;

  // string NewToken
  public NewToken?: string=null;

  // string PortalType
  public PortalType?: string=null;

  // int? ContactId
  public ContactId?: number=null;
}